export default __webpack_public_path__ + "static/media/Star.b4383d95.svg";